/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';
import { KeyGenerateType } from './KeyGenerateType';

export const KeyGenerate: core.serialization.ObjectSchema<serializers.KeyGenerate.Raw, Truvity.KeyGenerate> =
    core.serialization.object({
        type: KeyGenerateType,
    });

export declare namespace KeyGenerate {
    export interface Raw {
        type: KeyGenerateType.Raw;
    }
}
